import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { decorators } from "@orange-marmalade/paginate-this";
import * as actions from "MODULES/companies/actions";
import Delete from "MODULES/shared/components/Delete/Delete";
import { Authorized, DataTable } from "MODULES/shared/components";
import { CAN_ADD_COMPANIES } from "MODULES/users/constants";
import NewRelatedCompany from "MODULES/companies/components/Detail/RelatedCompanies/Create/NewRelatedCompany";
import EditRelatedCompany from "MODULES/companies/components/Detail/RelatedCompanies/Edit/EditRelatedCompany";
import { Link } from "react-router-dom";

class RelatedCompanies extends React.Component {
  state = {
    editRelatedCompanyModalOpen: false,
    selectedCompany: null
  };

  closeRelatedCompanyModal = () =>
    this.setState({ editRelatedCompanyModalOpen: false });

  launchModal = row => {
    this.setState({ editRelatedCompanyModalOpen: true, selectedCompany: row });
  };

  renderRow = row => {
    const relatedCompany = row.related_company;
    return (
      <tr
        key={row.id}
        className="clickable"
        onClick={() => this.launchModal(row)}
      >
        <td>
          <Link to={`/companies/${relatedCompany.uuid}`}>
            {relatedCompany.name}
          </Link>
        </td>
        <td>{get(relatedCompany, "primary_physical_address.care_of")}</td>
        <td>{get(relatedCompany, "primary_physical_address.line1")}</td>
        <td>{get(relatedCompany, "primary_physical_address.line2")}</td>
        <td>{get(relatedCompany, "primary_physical_address.city")}</td>
        <td>{get(relatedCompany, "primary_physical_address.state")}</td>
        <td>{get(relatedCompany, "primary_physical_address.postal_code")}</td>
        <td>{get(relatedCompany, "primary_physical_address.country")}</td>
        <Delete id={row.id} deleteAction={actions.destroyRelatedCompany} />
      </tr>
    );
  };

  render() {
    const { results, isLoading } = this.props;
    const { editRelatedCompanyModalOpen, selectedCompany } = this.state;

    return (
      <div>
        <h2>
          Related Companies
          <Authorized permissions={[CAN_ADD_COMPANIES]}>
            <NewRelatedCompany />
            <EditRelatedCompany
              open={editRelatedCompanyModalOpen}
              close={this.closeRelatedCompanyModal}
              relatedCompany={selectedCompany}
            />
          </Authorized>
        </h2>

        <DataTable.Mini loading={isLoading}>
          <DataTable.Head>
            <th>Name</th>
            <th>C/O</th>
            <th>Address Line 1</th>
            <th>Address Line 2</th>
            <th>City</th>
            <th>State/Province/Region</th>
            <th>ZIP/Postal Code</th>
            <th>Country</th>
            <th className="text-center">&nbsp;</th>
          </DataTable.Head>
          <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
        </DataTable.Mini>
      </div>
    );
  }
}

RelatedCompanies.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      care_of: PropTypes.string,
      line1: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postal_code: PropTypes.string,
      country: PropTypes.string,
      primary: PropTypes.bool
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired
};

const TabulateAttachments = decorators.tabulate(RelatedCompanies);
export default () => <TabulateAttachments listId="company/relatedCompanies" />;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/RelatedCompanies/RelatedCompanies.jsx